import React from 'react';

export const UploadSkuStateContext = React.createContext({});
